import { computed } from 'vue';
import { useProductType } from '~/composables/useProductType';
import { useProduct } from '~/modules/product/composables/useProduct';
import safeType from '~/utils/safeType';
import { getMemberDisplayGroupsMap } from '~/utils/product';
import useSelectedLatchkey from './useSelectedLatchkey';

/**
 * @param {Product} [product]
 * @returns {product is LatchKeyProduct}
 */
function isLatchKeyProduct(product) {
  if (!product) {
    return false;
  }

  const { isLatchKey } = useProductType();

  return isLatchKey;
}

/**
 *
 * @returns {{
 *  latchKeyGroups: import('vue').ComputedRef<string[]>,
 *  latchKeyProductIdsByGroup: import('vue').ComputedRef<Record<string,ProductId[]>>,
 *  selectedLatchkey: import('vue').WritableComputedRef<string>,
 * }}
 */
export default function useLatchkey() {
  const { productData: product } = useProduct();

  if (isLatchKeyProduct(product)) {
    const latchKeyGroups = computed(() => safeType(product.detail.orderedMasterGroupList, []));
    const latchKeyProductIdsByGroup = computed(() => getMemberDisplayGroupsMap(product));
    const selectedLatchkey = useSelectedLatchkey();

    return {
      latchKeyGroups,
      latchKeyProductIdsByGroup,
      selectedLatchkey,
    };
  }

  return {
    latchKeyGroups: computed(() => []),
    latchKeyProductIdsByGroup: computed(() => ({})),
    selectedLatchkey: computed(() => ''),
  };
}
